import {Component, Inject, OnInit} from '@angular/core';
import {CustomerPhoneService} from '../../core/services/customer-phone.service';
import {LegalEntity} from '../model/legal-entity.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../validator/customValidators';
import {EventBusService} from '../../core/services/event-bus.service';
import {DictionaryPosition} from '../model/dictionary.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {map} from "rxjs/operators";
import {ISimpleSelectableDataList} from "../model/interface/simple-selectable-data.model.interface";

@Component({
  selector: 'app-add-customer-phone',
  templateUrl: './add-customer-phone.component.html',
  styleUrls: ['./add-customer-phone.component.css']
})
export class AddCustomerPhoneComponent implements OnInit {
  legalEntity: LegalEntity;

  phoneForm: FormGroup;
  statuses: ISimpleSelectableDataList;

  constructor(private customerPhoneService: CustomerPhoneService,
              private eventBusService: EventBusService,
              private dialogRef: MatDialogRef<AddCustomerPhoneComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.legalEntity = data;
    this.createForm();
  }

  ngOnInit(): void {
    this.fetchStatuses();
  }

  addPhone() {
    return this.customerPhoneService.create(this.legalEntity.id, this.phoneForm.value)
      .subscribe((phone) => {
        this.eventBusService.display(DictionaryPosition.OK);
        this.legalEntity.phones.data.push(phone);
        this.phoneForm.reset();
        this.dialogRef.close();
      });
  }

  private createForm() {
    this.phoneForm = new FormGroup({
      phone: new FormControl(null, [CustomValidators.phoneValidator, Validators.required]),
      statusId: new FormControl(null, Validators.required)
    });
  }

  private fetchStatuses() {
    this.customerPhoneService.getStatuses()
      .pipe(
        map(list => list.toSimpleSelectableDataList())
      )
      .subscribe(list => this.statuses = list);
  }

}
